import React from 'react'
import { Head } from '@inertiajs/react'
import AdminLayout from '@/admin/shell/layouts/AdminLayout'
import UserProfileCard from '../components/UserProfileCard'
import type { UserProfilePageProps } from '../types'

function UserProfilePage({ user, plan, limits, usage, activity_heatmap }: UserProfilePageProps) {
  return (
    <>
      <Head title={`Admin — ${user.name}`} />
      <UserProfileCard user={user} plan={plan} limits={limits} usage={usage} activityHeatmap={activity_heatmap} />
    </>
  )
}

UserProfilePage.layout = (page: React.ReactNode) => (
  <AdminLayout title="User Profile">{page}</AdminLayout>
)

export default UserProfilePage
